import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/pages/audit-page/audit-page.component.ngfactory.ts